

import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography, Button, Card, CardContent, Grid, Chip } from '@mui/material';
import { useDispatch, useSelector } from "react-redux";
import { getOrderById } from "../../Redux/Customers/Order/Action";
import Ordercard from '../Profile/Component/Ordercard';

const OrderDetail = () => {
  const dispatch = useDispatch();
  const { orderId } = useParams(); // Get the order ID from the URL

  console.log(orderId)
  const orders = useSelector((state) => state.order?.order || {});
console.log(orders)
  useEffect(() => {
    if (orderId) {
           dispatch(getOrderById(orderId));
           console.log('Order ID from URL:', orders);

    }
  }, [orderId, dispatch]);

  if (!orders || Object.keys(orders).length === 0) {
    return <Typography variant="h6">Loading...</Typography>;
  }

  return (
    <Box sx={{ p: 3 }}>
          {/* Order Header */}
          <Typography variant="h5" gutterBottom>
  Order / Order details
    </Typography>
    
          <Typography variant="h6" gutterBottom>
            Order #{orders._id}
          </Typography>
    
          <Chip label={orders.orderStatus}  sx={{ mb: 2 , fontWeight:"bold",bgcolor:"#41A317"}} />
    
          {/* Date Info */}
          <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
            <Typography variant="body2">Paid on: {new Date(orders.orderDate).toLocaleString()}</Typography>
            <Typography variant="body2">Placed on:{new Date(orders.createdAt).toLocaleString()}</Typography>
            <Typography variant="body2">Updated: {orders.updatedAt}</Typography>
          </Box>
    
           {/* Combined Card for All Information */}
           <Card variant="outlined">
             <CardContent>
               <Grid container spacing={2}>
                 <Grid item xs={12} sm={6}>
        
                  <Typography variant="h6">Customer & Order</Typography>
                  <Typography><strong>Name:</strong> {orders.user.firstName} {orders.user.lastName}</Typography>
                  <Typography><strong>Email:</strong> {orders.user.email}</Typography>
                  <Typography><strong>Phone:</strong> {orders.user.mobile || "N/A" }</Typography>
                </Grid>
    
               <Grid item xs={12} sm={6}>
                 <Typography variant="h6">Shipping Address</Typography>
                 <Typography><strong>Name:</strong> {orders.shippingAddress.firstName} {orders.shippingAddress.lastName}</Typography>
                 <Typography><strong>City:</strong> {orders.shippingAddress.city}</Typography>
                 <Typography><strong>Address:</strong> {orders.shippingAddress.streetAddress}</Typography>
                 <Typography><strong>State:</strong> {orders.shippingAddress.state}</Typography>
                 <Typography><strong>Zip Code:</strong> {orders.shippingAddress.zipCode}</Typography>
                 <Typography><strong>Phone:</strong> {orders.shippingAddress.mobile}</Typography>
               </Grid>
             </Grid>
    
               {/* Order Items */}
               <Typography variant="h6" sx={{ mt: 2 }}>Order Items</Typography>
               <Grid container spacing={2}>
                 {orders.orderItems?.map((item) => (
                  <Grid item xs={12} sm={6} key={item._id}>
               <Ordercard
          key={item._id}
          status={orders.orderStatus}
          date={new Date(orders.createdAt).toLocaleDateString()}
          imageSrc={item.product.imageUrl|| "https://placehold.co/50x50"}
          orderID={item._id}
          brand={item.product.brand}
          color = {item.product.color}
          description = {item.product.description}
          rating = {item.product.numRating}
          items={item.product?.title}
          price={item.product.price}
          size = {item.size}
        />
                  </Grid>
                ))}
              </Grid>
    
              {/* Total Price */}
              <Typography variant="h6" sx={{ mt: 2 }}>
                <strong>Total Price:</strong> ₹{orders.totalPrice}
              </Typography>
            </CardContent>
          </Card>
    
          {/* Back Button */}
          <Button variant="contained" color="primary" onClick={() => window.history.back()} sx={{ mt: 2 }}>
            Back
          </Button>
        </Box>
      );
    };
    
    export default OrderDetail;
    